package io.horion.auth.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class SsoCodeResponse(
    val code: String,
    val identifier: String
)
